import React from 'react';

import styles from './Card.module.scss';


const DESIGN = {
  1: {
    ul: styles.Ornament1UL,
    ur: styles.Ornament1UR,
    dl: styles.Ornament1DL,
    dr: styles.Ornament1DR,
  },
  2: {
    ul: styles.Ornament2UL,
    ur: styles.Ornament2UR,
    dl: styles.Ornament2DL,
    dr: styles.Ornament2DR,
  }
};

const Card = (props) => {
  const ornament = DESIGN.hasOwnProperty(props.design) ? DESIGN[props.design] : DESIGN[1];

  return (
    <div className={styles.Card}>
      <div className={ornament.ul}/>
      <div className={ornament.ur}/>
      <div className={ornament.dl}/>
      <div className={ornament.dr}/>
      <div className={styles.Description}>{props.description}</div>
    </div>
  );
};

Card.defaultProps = {
  description: '',
  design: 1,
};

export default Card;
